import React from 'react';
import CAppFilterSelect from '../../../../../../../app/components/CAppFilterSelect';
import IInvestExpertiseFilters from '../../../../../interfaces/expertise/IInvestExpertiseFilters';
import { useTranslation } from 'react-i18next';
import investmentFilterLang from '../../../langs/investmentFilterLang';

type CFiltersVintageSelectProps = {
	optionsVintages: { id: number; name: string }[];
	filters: IInvestExpertiseFilters;
	onChange: (filters: IInvestExpertiseFilters) => void;
};

const CFiltersVintageSelect = (props: CFiltersVintageSelectProps) => {
	const { optionsVintages, filters, onChange } = props;

	const { t } = useTranslation();

	return (
		<CAppFilterSelect
			className="filter-vintage"
			label={t(investmentFilterLang.vintage.tag)}
			value={filters && filters.vintage ? optionsVintages.find((x) => x.id === filters.vintage) : null}
			onChange={(val: { id: number; name: string }) => {
				onChange({
					...filters,
					vintage: val ? val.id : null,
				});
			}}
			size="small"
			options={optionsVintages}
		/>
	);
};

export default CFiltersVintageSelect;
